<template>
    <v-card>
        <div style="padding: 16px 24px 10px">
            <s-crud 
                add
                edit
                @save="save($event)"
                height="auto" 
                remove
                @removed="remove()"
                title="Condiciones"
                :config="config"
                :filter="filter"
                searchInput
                close
                @close="$emit('close')"
                ref = "UtilityTaskCondition"
            >

            <template scope="props">
                <v-row>
                    <v-col cols="12" sm="12" md="12">
                        <s-text class="s-col-form" label="Actividad" placeholder="Nueva actividad" v-model="props.item.TkcName"></s-text>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:Approval="{ row }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            :color="row.TkcStatus === 1 ? 'green' : 'red'"
                            icon
                            @click="toggleApproval(row)"
                            style="margin: 0; padding: 0; height: 32px; width: 32px;"
                        >
                            <v-icon dark>
                                {{ row.TkcStatus === 1 ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>{{ row.TkcStatus === 1 ? 'Aprobado' : 'Por Aprobar' }}</span>
                </v-tooltip>
            </template>
            <template v-slot:TkcDate="{ row }">
                    {{ $fun.formatDateTimeView(row.SecCreate) }}
                </template>
            <template v-slot:Actions="{ row }">
                <v-btn x-small color="error" @click="deleteTasks(row)" v-if="edit">
                    <v-icon>mdi-delete-circle</v-icon>
                </v-btn>
            </template>
            </s-crud>
        </div>
        <v-card-text>
            <v-row>
                <v-col class="lg-12">
                    <v-progress-linear
                        :value="progress"
                        color="light-blue"
                        height="25"
                        rounded
                        striped
                        readonly
                    >
                        <template v-slot:default="{ value }">
                            <strong>{{ Math.ceil(value) }}%</strong>
                        </template>
                    </v-progress-linear>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import _sTaskConditionService from '@/services/InformationTechnology/TaskConditionService.js';
	export default {
		props: {
			item : {
                type: Object,
                default: () => {}
            },
            approval : {
                type: Boolean,
                default: false
            },
            edit : {
                type: Boolean,
                default: false
            }
        },
		data() {
			return {
				openDialog: false,
                filter : {},
                items: [],
                selected: [],
                TkcStatus: false,
                config : {
                    service: _sTaskConditionService,
                    model: {
                        TkcID: "ID",
                    },
                    headers: [
                        { text: 'Estado', value: 'Approval' },
                        { text: 'ID', value: 'TkcID' },
                        { text: 'Condición', value: 'TkcName' },
                        { text: 'Fecha Registro', value: 'TkcDate' }
                    ]
                },
			};
		},
        computed: {
            progress() {
                if (this.items.length === 0) return 0; // Si no hay tareas, progreso es 0%
                const completed = this.items.filter(item => item.TkcStatus === 1).length;
                return (completed / this.items.length) * 100;
            }
        },
		methods: {
            loadTasks (){
                _sTaskConditionService.list(this.filter, this.$fun.getUserID())
                    .then(resp => {
                        if(resp.status == 200){
                            this.items = resp.data;
                        }
                    });
            },
            save(item) {

                if(item.TkcName == "") {
                    this.$fun.alert("Debes ingresar una condición", "warning");
                    return;
                }

                item.UsrCreateID = this.$fun.getUserID();
                item.TskID = this.item.TskID;
                this.$fun.alert("Seguro de Guardar?", "question")
                    .then(r => {
                        if(r.value){
                            _sTaskConditionService.save(item, this.$fun.getUserID())
                                .then(resp => {
                                    if(resp.status == 200){
                                        this.$fun.alert("Se agrego correctamente", "success");
                                        this.$refs.UtilityTaskCondition.refresh();
                                        this.loadTasks();
                                    }
                                });
                           
                        }
                    });
            },
            remove(){
                this.loadTasks();
            },
            toggleApproval(item) {
                item.TkcStatus = item.TkcStatus === 1 ? 0 : 1;
                _sTaskConditionService.save(item, this.$fun.getUserID())
                    .then(resp => {
                        console.log("resp:", resp);
                        if (resp.status === 200) {
                            this.loadTasks();
                            this.$fun.alert("Estado actualizado correctamente", "success");
                        } else {
                            this.$fun.alert("Error al actualizar estado", "error");
                        }
                    })
                    .catch(() => {
                        this.$fun.alert("Error de conexión", "error");
                    });
            }
		},
        mounted (){
            this.filter.TskID = this.item.TskID;
            this.loadTasks();
        }
	};
</script>

<style>
.bordered-div {
	border: 1px solid grey; /* Borde negro de 2px */
	padding: 10px; /* Espaciado dentro del div */
	margin: 5px;
	border-radius: 5px; /* Esquinas redondeadas opcionales */
}
</style>
